(function(){
  "use strict";

  const API_BASE = "https://bubbly-vibrancy-production.up.railway.app";

  function toast(message, type = "info", persist = false){
    let box = document.getElementById("mtsBridgeToast");
    if(!box){
      box = document.createElement("div");
      box.id = "mtsBridgeToast";
      box.style.cssText = [
        "position:fixed",
        "right:22px",
        "bottom:22px",
        "z-index:999999",
        "max-width:680px",
        "padding:16px 18px",
        "border-radius:16px",
        "font-weight:900",
        "font-size:14px",
        "line-height:1.35",
        "color:#fff",
        "box-shadow:0 18px 60px rgba(0,0,0,.35)",
        "background:linear-gradient(90deg,#ff2b2b,#7b2cff,#00d4ff)"
      ].join(";");
      document.body.appendChild(box);
    }

    box.innerHTML = message;
    if(type === "error") box.style.background = "linear-gradient(90deg,#ff2b2b,#b00020)";
    if(type === "success") box.style.background = "linear-gradient(90deg,#0bbf6a,#00d4ff)";
    if(type === "warn") box.style.background = "linear-gradient(90deg,#ff9b00,#7b2cff)";
    clearTimeout(box._timer);
    if(!persist) box._timer = setTimeout(()=>box.remove(), 11000);
  }

  function isEmail(email){
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(String(email || "").trim());
  }

  function textOf(selector, root = document){
    const el = root.querySelector(selector);
    return el ? String(el.value || el.textContent || "").trim() : "";
  }

  function numberFromText(value){
    const match = String(value || "").replace(/\s/g, "").replace(",", ".").match(/-?\d+(\.\d+)?/);
    return match ? Number(match[0]) : 0;
  }

  function detailRoot(){
    return document.getElementById("mtsProjectDetail") || document.querySelector(".mts-crm-detail") || document;
  }

  function activeProjectElement(){
    return document.querySelector("[data-request-id].active") ||
      document.querySelector("[data-project-id].active") ||
      document.querySelector(".active[data-id]") ||
      document.querySelector("[data-request-id]") ||
      document.querySelector("[data-project-id]");
  }

  function activeProjectId(){
    const el = activeProjectElement();
    return el?.dataset?.requestId || el?.dataset?.projectId || el?.dataset?.id || "";
  }

  function currentProjectObject(){
    const id = activeProjectId();
    if(!id || !window.MTS?.state?.projects) return null;
    return window.MTS.state.projects.find(project=>project.id === id) || null;
  }

  function findEmail(root){
    const project = currentProjectObject();
    return [
      project?.email,
      project?.customerEmail,
      project?.customer?.email,
      textOf('input[type="email"]', root),
      textOf('[data-field="email"]', root),
      textOf("[data-email]", root),
      textOf(".mts-project-email", root),
      textOf(".mts-client-email", root),
      root.querySelector("[href^='mailto:']")?.getAttribute("href")?.replace(/^mailto:/, ""),
      root.textContent.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i)?.[0],
      document.body.textContent.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i)?.[0]
    ].filter(Boolean).find(isEmail) || "";
  }

  function findPrice(root){
    const project = currentProjectObject();
    if(project?.quote?.total) return Number(project.quote.total);
    if(project?.autoQuote?.quote?.final) return Number(project.autoQuote.quote.final);
    if(project?.autoQuote?.quote?.suggested) return Number(project.autoQuote.quote.suggested);

    const selectors = [
      "[data-quote-total]",
      "[data-price]",
      ".mts-price",
      ".mts-quote-total",
      ".mts-final-price",
      ".mts-client-quote-main strong",
      ".mts-v7-price strong",
      ".mts-pro-price strong",
      ".mts-price-total strong"
    ];

    for(const selector of selectors){
      const value = numberFromText(textOf(selector, root));
      if(value > 0) return value;
    }

    const patterns = [
      /Prix final client[^0-9]*([0-9]+[,.]?[0-9]*)/i,
      /Prix final[^0-9]*([0-9]+[,.]?[0-9]*)/i,
      /Prix conseille[^0-9]*([0-9]+[,.]?[0-9]*)/i,
      /Total[^0-9]*([0-9]+[,.]?[0-9]*)/i
    ];

    for(const pattern of patterns){
      const value = numberFromText(root.textContent.match(pattern)?.[1]);
      if(value > 0) return value;
    }

    return 0;
  }

  function collectProject(){
    const root = detailRoot();
    const project = currentProjectObject();
    return {
      ...(project || {}),
      id: activeProjectId(),
      email: findEmail(root),
      name: project?.name || project?.customerName || project?.customer?.name || textOf('[data-field="name"]', root) || textOf(".mts-project-name", root) || textOf("h3", root) || "Client MoRetro",
      price: findPrice(root),
      projectType: project?.projectType || project?.title || textOf('[data-field="projectType"]', root) || textOf("[data-project-type]", root) || textOf(".mts-project-type", root) || "Projet sur mesure MoRetro 3D",
      message: project?.message || project?.description || textOf("textarea", root) || textOf('[data-field="message"]', root) || textOf(".mts-project-message") || textOf(".mts-project-description") || "Demande creee depuis MoRetro Studio."
    };
  }

  function loadHtml2Pdf(){
    if(typeof window.html2canvas === "function" && window.jspdf?.jsPDF) return Promise.resolve(true);
    if(window.__mtsHtml2PdfPromise) return window.__mtsHtml2PdfPromise;
    const load = (src, ready, label)=>new Promise((resolve, reject)=>{
      if(ready()) return resolve(true);
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = ()=>ready() ? resolve(true) : reject(new Error(`${label} charge mais indisponible.`));
      script.onerror = ()=>reject(new Error(`Impossible de charger ${label}.`));
      document.head.appendChild(script);
    });
    window.__mtsHtml2PdfPromise = Promise.all([
      load("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js", ()=>typeof window.html2canvas === "function", "html2canvas"),
      load("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js", ()=>!!window.jspdf?.jsPDF, "jsPDF")
    ]).then(()=>true);
    return window.__mtsHtml2PdfPromise;
  }

  function blobBase64(blob){
    return new Promise((resolve, reject)=>{
      const reader = new FileReader();
      reader.onload = ()=>resolve(String(reader.result || "").split(",")[1] || "");
      reader.onerror = ()=>reject(reader.error || new Error("Lecture du PDF impossible."));
      reader.readAsDataURL(blob);
    });
  }

  async function buildStudioQuoteAttachment(project){
    const quotes = window.MTS?.Quotes;
    const data = quotes?.getCurrentQuote?.(project) || project?.autoQuote || project?.quote;
    if(!quotes?.buildQuoteHtml || !data) throw new Error("Genere d'abord le devis PDF dans le Studio.");

    await loadHtml2Pdf();
    const source = new DOMParser().parseFromString(quotes.buildQuoteHtml(project, data), "text/html");
    source.querySelectorAll(".actions,script").forEach(node=>node.remove());
    const isolatedStyle = source.createElement("style");
    isolatedStyle.textContent = "html,body{margin:0!important;padding:0!important;background:#fff!important}.page{width:760px!important;max-width:760px!important;margin:0!important;border-radius:0!important;box-shadow:none!important}";
    source.head.appendChild(isolatedStyle);

    const frame = document.createElement("iframe");
    frame.title = "Preparation du devis PDF";
    frame.style.cssText = "position:fixed;left:0;top:0;width:760px;height:1200px;border:0;z-index:-1;pointer-events:none;background:#fff;";
    document.body.appendChild(frame);
    const frameDoc = frame.contentDocument;
    frameDoc.open();
    frameDoc.write("<!doctype html>" + source.documentElement.outerHTML);
    frameDoc.close();
    await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));

    const quoteNumber = data.quoteNumber || project.quoteNumber || project.id || "MoRetro";
    const filename = `Devis-${String(quoteNumber).replace(/[^a-z0-9_-]+/gi,"-")}.pdf`;
    try{
      const target = frameDoc.querySelector(".page");
      if(!target) throw new Error("Le contenu du devis est introuvable.");
      frame.style.height = `${Math.ceil(target.scrollHeight + 4)}px`;
      const canvas = await window.html2canvas(target, {
        scale:2,
        useCORS:true,
        backgroundColor:"#ffffff",
        logging:false,
        scrollX:0,
        scrollY:0,
        windowWidth:760,
        windowHeight:Math.ceil(target.scrollHeight)
      });
      const Pdf = window.jspdf?.jsPDF;
      if(!Pdf) throw new Error("Le moteur A4 du Studio est indisponible.");
      const pdf = new Pdf({unit:"mm", format:"a4", orientation:"portrait", compress:true});
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 14;
      const maxWidth = pageWidth - margin * 2;
      const maxHeight = pageHeight - margin * 2;
      const ratio = Math.min(maxWidth / canvas.width, maxHeight / canvas.height);
      const width = canvas.width * ratio;
      const height = canvas.height * ratio;
      const x = (pageWidth - width) / 2;
      const y = (pageHeight - height) / 2;
      pdf.addImage(canvas.toDataURL("image/jpeg",0.98), "JPEG", x, y, width, height, undefined, "FAST");
      const blob = pdf.output("blob");
      const base64 = await blobBase64(blob);
      if(!base64) throw new Error("Le PDF genere est vide.");
      return {base64, filename};
    }finally{
      frame.remove();
    }
  }

  async function updateProjectFirestore(data){
    const projectId = activeProjectId();
    if(!projectId || !window.MTS?.state?.db) return false;
    await window.MTS.state.db.collection("custom_requests").doc(projectId).update({
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    });

    const project = window.MTS.state.projects?.find(item=>item.id === projectId);
    if(project) Object.assign(project, data);
    return true;
  }

  async function railwayJson(path, options = {}){
    const url = API_BASE + path;
    const response = await fetch(url, {
      ...options,
      mode: "cors",
      cache: "no-store",
      credentials: "omit",
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {})
      }
    });

    const text = await response.text();
    let json = null;
    try{
      json = text ? JSON.parse(text) : {};
    }catch(err){
      throw new Error(`Railway a repondu ${response.status}, mais pas en JSON.`);
    }

    if(!response.ok || json.ok === false){
      const error = new Error(json.error || `Railway HTTP ${response.status}`);
      error.payload = json;
      throw error;
    }

    return json;
  }

  async function testRailway(){
    try{
      await railwayJson("/health", {method: "GET", headers: {}});
      return true;
    }catch(err){
      return false;
    }
  }

  function explainNetworkError(err){
    const msg = String(err?.message || err || "");
    if(/Failed to fetch|NetworkError|Load failed/i.test(msg)){
      return [
        "Railway inaccessible depuis ton navigateur.",
        "A verifier : cache navigateur, extension bloqueuse, URL Railway, ou redemarrage Railway.",
        `<a href="${API_BASE}/health" target="_blank" style="color:#fff;text-decoration:underline">Tester Railway /health</a>`
      ].join("<br>");
    }
    return msg;
  }

  function showResult(json){
    const root = detailRoot();
    let result = document.getElementById("mtsShopifyResult");
    if(!result){
      result = document.createElement("div");
      result.id = "mtsShopifyResult";
      result.style.cssText = "margin-top:14px;padding:14px;border-radius:14px;background:rgba(0,212,255,.12);border:1px solid rgba(0,212,255,.35);color:white;font-weight:800;display:grid;gap:8px;";
      (root.querySelector(".mts-analysis-card") || root.querySelector(".mts-v7-action-zone") || root.querySelector(".mts-pro-actions") || root.querySelector(".mts-card") || root).appendChild(result);
    }

    result.innerHTML = `
      <div>✅ Devis Shopify : ${json.draftOrderName || "cree"}</div>
      ${json.invoiceUrl ? `
        <div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">
          <a href="${json.invoiceUrl}" target="_blank" rel="noopener" style="color:#9eefff">Ouvrir le lien de paiement</a>
          <button type="button" id="mtsCopyShopifyLink" style="border:0;border-radius:999px;padding:8px 11px;background:#111;color:#fff;font-weight:900;cursor:pointer">Copier le lien</button>
          <button type="button" id="mtsCheckPayment" style="border:0;border-radius:999px;padding:8px 11px;background:#0b7;color:#fff;font-weight:900;cursor:pointer">Verifier paiement</button>
        </div>` : ""}
    `;

    const copy = document.getElementById("mtsCopyShopifyLink");
    if(copy && json.invoiceUrl){
      copy.onclick = async()=>{
        await navigator.clipboard.writeText(json.invoiceUrl);
        toast("Lien de paiement copie.", "success");
      };
    }

    const check = document.getElementById("mtsCheckPayment");
    if(check && json.draftOrderId) check.onclick = ()=>checkPayment(json.draftOrderId);
  }

  async function callShopify(endpoint, label){
    const project = collectProject();

    if(!isEmail(project.email)){
      const manual = prompt("Email du client pour le devis Shopify ?");
      if(!manual){
        toast("Email client obligatoire pour envoyer/creer un devis Shopify.", "error");
        return;
      }
      project.email = manual.trim();
    }

    if(!isEmail(project.email)){
      toast("Email invalide : " + project.email, "error");
      return;
    }

    if(!project.price || project.price <= 0){
      const price = prompt("Prix final TTC du devis (€) ?");
      if(!price) return;
      project.price = numberFromText(price);
    }

    toast(label + " en cours...");

    try{
      const healthOk = await testRailway();
      if(!healthOk) throw new Error("Failed to fetch");

      const payload = {project};
      if(endpoint === "/api/shopify/send-quote"){
        toast("Preparation du PDF du Studio...");
        const attachment = await buildStudioQuoteAttachment(project);
        payload.quotePdfBase64 = attachment.base64;
        payload.quotePdfName = attachment.filename;
      }

      const json = await railwayJson(endpoint, {
        method: "POST",
        body: JSON.stringify(payload)
      });

      await updateProjectFirestore({
        status: json.sent ? "quote_sent" : "quoted",
        shopifyDraftOrderId: json.draftOrderId,
        shopifyDraftOrderName: json.draftOrderName,
        shopifyInvoiceUrl: json.invoiceUrl
      }).catch(err=>console.warn("Firestore update skipped:", err.message));

      showResult(json);
      toast(json.sent ? "Devis envoye au client." : "Devis Shopify cree.", "success");
    }catch(err){
      const payload = err?.payload || {};
      if(payload.authRequired && payload.authUrl){
        toast(`Shopify doit etre reconnecte une fois.<br><br><a href="${payload.authUrl}" target="_blank" style="color:#fff;text-decoration:underline">Reconnecter Shopify</a>`, "warn", true);
        return;
      }

      console.error("MoRetro Railway/Shopify error:", err);
      toast("Erreur Railway : " + explainNetworkError(err), "error", true);
    }
  }

  async function checkPayment(draftOrderId){
    toast("Verification du paiement...");
    try{
      const json = await railwayJson("/api/shopify/draft-order-status", {
        method: "POST",
        body: JSON.stringify({draftOrderId})
      });

      if(json.paid){
        await updateProjectFirestore({
          status: "paid",
          shopifyOrderId: json.orderId,
          shopifyOrderName: json.orderName,
          paidAt: new Date().toISOString()
        }).catch(err=>console.warn("Firestore paid update skipped:", err.message));

        toast(`Paiement confirme ✅ ${json.orderName || ""}`, "success");
      }else{
        toast("Paiement pas encore detecte.", "warn");
      }
    }catch(err){
      console.error(err);
      toast("Erreur verification paiement : " + explainNetworkError(err), "error", true);
    }
  }

  function injectShopifyButtons(){
    const root = detailRoot();
    if(!root || document.getElementById("mtsBridgeActions")) return;

    const target = root.querySelector("#mtsAnalysisCard") ||
      root.querySelector(".mts-analysis-card") ||
      root.querySelector(".mts-client-quote") ||
      root.querySelector(".mts-quote-auto") ||
      root;

    const storedDraft = currentProjectObject()?.shopifyDraftOrderId || "";
    const wrap = document.createElement("div");
    wrap.id = "mtsBridgeActions";
    wrap.style.cssText = "display:flex;gap:10px;flex-wrap:wrap;margin-top:14px;";
    wrap.innerHTML = `
      <button type="button" class="mts-btn mts-soft" data-mts-shopify-action="create">🛒 Creer devis Shopify</button>
      <button type="button" class="mts-btn mts-ok" data-mts-shopify-action="send">📧 Envoyer devis + lien paiement</button>
      ${storedDraft ? `<button type="button" class="mts-btn mts-soft" data-mts-shopify-action="check" data-draft-id="${storedDraft}">✅ Verifier paiement</button>` : ""}
    `;
    target.appendChild(wrap);
  }

  function attach(){
    window.MTS = window.MTS || {};
    window.MTS.shopifyBridgeVersion = "pdf-a4-isole-2026-07-15-3";
    document.addEventListener("click", function(event){
      const btn = event.target.closest("button,a");
      if(!btn) return;

      const action = btn.dataset?.mtsShopifyAction;
      const label = String(btn.textContent || "").toLowerCase();

      if(action === "create" || label.includes("creer devis shopify") || label.includes("créer devis shopify") || label.includes("creer draft shopify")){
        event.preventDefault();
        event.stopImmediatePropagation();
        callShopify("/api/shopify/create-draft-order", "Creation du devis Shopify");
        return;
      }

      if(action === "send" || label.includes("envoyer devis shopify") || label.includes("envoyer devis + lien") || label.includes("envoyer le devis client")){
        event.preventDefault();
        event.stopImmediatePropagation();
        callShopify("/api/shopify/send-quote", "Envoi du devis Shopify");
        return;
      }

      if(action === "check"){
        event.preventDefault();
        event.stopImmediatePropagation();
        const id = btn.dataset.draftId || currentProjectObject()?.shopifyDraftOrderId;
        if(id) checkPayment(id);
        else toast("Aucun devis Shopify enregistre pour ce projet.", "error");
      }
    }, true);

    setInterval(injectShopifyButtons, 1200);
    injectShopifyButtons();
  }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", attach);
  else attach();
})();
